import clsx from "clsx";

import type { OptionGroupRecord } from "../../services/options";

interface OptionGroupListProps {
  groups: OptionGroupRecord[];
  selectedId: string | null;
  onSelect: (groupId: string | null) => void;
  onDelete: (group: OptionGroupRecord) => void;
  onCreate: () => void;
  canClear?: boolean;
}

function OptionGroupTable({
  groups,
  selectedId,
  onSelect,
  onDelete,
}: {
  groups: OptionGroupRecord[];
  selectedId: string | null;
  onSelect: (groupId: string) => void;
  onDelete: (group: OptionGroupRecord) => void;
}) {
  if (groups.length === 0) {
    return (
      <div className="empty-state">
        <strong>Opsiyon grubu bulunamadı</strong>
        <p>Sağ üstteki butonu kullanarak ilk opsiyon grubunu oluşturun.</p>
      </div>
    );
  }

  return (
    <div className="table-wrapper">
      <table className="data-table">
        <thead>
          <tr>
            <th>Ad</th>
            <th>Slug</th>
            <th>Tip</th>
            <th>Min/Max</th>
            <th>Zorunlu</th>
            <th>Öncelik</th>
            <th>İşlemler</th>
          </tr>
        </thead>
        <tbody>
          {groups.map((group) => (
            <tr
              key={group.id}
              className={clsx({ active: selectedId === group.id })}
              onClick={() => onSelect(group.id)}
            >
              <td>{group.name}</td>
              <td>{group.slug}</td>
              <td>{group.selectionType === "single" ? "Tek" : "Çoklu"}</td>
              <td>
                {group.minSelections ?? 0}
                {group.maxSelections != null ? ` / ${group.maxSelections}` : ""}
              </td>
              <td>
                <span className={`chip ${group.isRequired ? "success" : "ghost"}`}>
                  {group.isRequired ? "Evet" : "Hayır"}
                </span>
              </td>
              <td>{group.priority}</td>
              <td>
                <div className="form-row" style={{ gap: "0.5rem" }}>
                  <button
                    type="button"
                    className="button secondary"
                    onClick={(event) => {
                      event.stopPropagation();
                      onSelect(group.id);
                    }}
                  >
                    Düzenle
                  </button>
                  <button
                    type="button"
                    className="button danger"
                    onClick={(event) => {
                      event.stopPropagation();
                      onDelete(group);
                    }}
                  >
                    Sil
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function OptionGroupList({
  groups,
  selectedId,
  onSelect,
  onDelete,
  onCreate,
  canClear = Boolean(selectedId),
}: OptionGroupListProps) {
  return (
    <div className="card">
      <div className="card-header">
        <div>
          <p className="card-title">Opsiyon grupları</p>
          <p className="card-subtitle">
            {groups.length === 0
              ? "Henüz kayıt yok"
              : `${groups.length} grup listeleniyor`}
          </p>
        </div>
        <div className="form-row" style={{ gap: "0.5rem" }}>
          <button
            type="button"
            className="button ghost"
            disabled={!canClear}
            onClick={() => onSelect(null)}
          >
            Temizle
          </button>
          <button type="button" className="button primary" onClick={onCreate}>
            Yeni grup
          </button>
        </div>
      </div>
      <OptionGroupTable
        groups={groups}
        selectedId={selectedId}
        onSelect={onSelect}
        onDelete={onDelete}
      />
    </div>
  );
}
